import { DeleteOutlined, AppstoreOutlined } from '@ant-design/icons';

/**
 * Renders the popup modal title with a section-style icon box + bold label,
 * matching the AddFormV1.css card header design.
 *
 * @param {Object} props
 * @param {string} [props.titleText]
 * @param {string} [props.titleIcon]  - 'delete' for danger style; omit for default
 */
export default function PopupHeader({ titleText, titleIcon }) {
  const isDelete = titleIcon === 'delete';

  return (
    <span className="dynamic-popup__header">
      <span className={`dynamic-popup__header-icon-box${isDelete ? ' dynamic-popup__header-icon-box--danger' : ''}`}>
        {isDelete ? <DeleteOutlined /> : <AppstoreOutlined />}
      </span>
      <span className="dynamic-popup__header-label">{titleText}</span>
    </span>
  );
}
